export const smtpFormSchema = [
  {
    name: 'host',
    title: 'Host',
    description: 'SMTP server hostname',
    type: 'text',
    lgWidth: 2,
    required: true
  },
  {
    name: 'port',
    title: 'Port',
    description: 'SMTP server port',
    type: 'text',
    lgWidth: 1,
    required: true
  },
  {
    name: 'user',
    title: 'User',
    description: 'SMTP authentication username',
    type: 'text',
    lgWidth: 2,
    required: true
  },
  {
    name: 'pass',
    title: 'Password',
    description: 'SMTP authentication password',
    type: 'text',
    lgWidth: 2,
    required: true
  },
  {
    name: 'fromName',
    title: 'From Name',
    description: 'Sender display name',
    type: 'text',
    lgWidth: 2,
    required: false
  },
  {
    name: 'fromEmail',
    title: 'From Email',
    description: 'Sender email address',
    type: 'text',
    lgWidth: 2,
    required: false
  },
  {
    name: 'secure',
    title: 'SSL/TLS',
    description: 'Enable secure SMTP connection',
    type: 'checkbox',
    lgWidth: 1,
    required: false,
    defaultValue: false
  }
]
